module.exports = __webpack_public_path__ + "media/images/slider_sp_bg-cccceea663ff52c78d48f9a33a7fe573.png";